import { supabase } from '@/lib/supabaseClient'

export async function fetchProjectUpdates(projectId) {
  const { data, error } = await supabase
    .from('project_updates')
    .select('*')
    .eq('project_id', projectId)
    .order('created_at', { ascending: false })

  if (error) throw error
  return data
}

export async function createProjectUpdate(updateData) {
  const { data, error } = await supabase
    .from('project_updates')
    .insert([updateData])
    .select()
    .single()

  if (error) throw error
  return data
}

export async function updateProjectUpdate(id, updates) {
  const { data, error } = await supabase
    .from('project_updates')
    .update({ ...updates, updated_at: new Date().toISOString() })
    .eq('id', id)
    .select()
    .single()

  if (error) throw error
  return data
}

export async function deleteProjectUpdate(id) {
  const { error } = await supabase
    .from('project_updates')
    .delete()
    .eq('id', id)

  if (error) throw error
}
